module.exports = __webpack_public_path__ + "img/esg_ch4.19df3cfa.svg";